/*
  Product page and quick view: no size is chosen until the shopper picks one.

  Shopify always loads a product with its first available variant, so the
  theme highlights XS and "Add to bag" would add XS without anyone choosing it.
  Until a size tile is tapped this script:
    - clears the highlighted size tile and the size shown in the sticky bar,
    - relabels the add-to-bag buttons "Διάλεξε μέγεθος",
    - turns a tap on those buttons (or on PayPal) into a nudge to the size row.
  On the product page a link that names a variant (?variant=…, e.g. from the
  cart or an ad) keeps that variant selected and skips all of this. The quick
  view (opened from a product card) is set up each time it loads a product.
*/
(function () {
  var PROMPT = 'Διάλεξε μέγεθος';
  var pageNamesVariant = new URLSearchParams(window.location.search).has('variant');

  function setup(root) {
    root.querySelectorAll('[data-size-option]').forEach(function (sizeOption) {
      if (sizeOption.dataset.sizePendingSetup) return;
      sizeOption.dataset.sizePendingSetup = 'true';
      var inQuickView = !!sizeOption.closest('[data-is-quick-view], [data-quick-view-modal]');
      if (pageNamesVariant && !inQuickView) return;
      var chips = sizeOption.querySelectorAll('.product__chip');
      if (chips.length < 2) return;

      var scope = sizeOption.closest('[data-section-type]') || document;
      var buttons = scope.querySelectorAll('[data-add-to-cart]');
      var payment = scope.querySelectorAll('.shopify-payment-button');
      var stickyOptions = scope.querySelector('.sticky-atc-bar__meta-options');
      var originals = [];

      buttons.forEach(function (button) {
        var label = button.querySelector('[data-add-to-cart-text]');
        if (!label) return;
        originals.push({ label: label, text: label.textContent, aria: button.getAttribute('aria-label') });
        if (!button.disabled) {
          label.textContent = PROMPT;
          button.setAttribute('aria-label', PROMPT);
        }
      });
      var stickyText = stickyOptions ? stickyOptions.textContent : '';
      if (stickyOptions) stickyOptions.textContent = '';

      chips.forEach(function (chip) {
        chip.classList.remove('selected');
      });
      scope.setAttribute('data-size-pending', '');

      function choose() {
        if (!scope.hasAttribute('data-size-pending')) return;
        scope.removeAttribute('data-size-pending');
        originals.forEach(function (entry) {
          // Theme JS rewrites these on a variant change; this covers picking
          // the size that was already loaded, which fires no change.
          if (entry.label.textContent === PROMPT) entry.label.textContent = entry.text;
          var button = entry.label.closest('[data-add-to-cart]');
          if (button && entry.aria) button.setAttribute('aria-label', entry.aria);
        });
        if (stickyOptions && !stickyOptions.textContent.trim()) stickyOptions.textContent = stickyText;
      }

      function nudge(event) {
        if (!scope.hasAttribute('data-size-pending')) return;
        event.preventDefault();
        event.stopPropagation();
        sizeOption.scrollIntoView({ block: inQuickView ? 'nearest' : 'center', behavior: 'smooth' });
        sizeOption.classList.remove('is-asking');
        // Restart the cue even on a second tap.
        void sizeOption.offsetWidth;
        sizeOption.classList.add('is-asking');
      }

      sizeOption.addEventListener('click', function (event) {
        if (event.target.closest('.product__chip')) choose();
      }, true);

      // Capture phase so the theme's submit handlers never see the tap.
      buttons.forEach(function (button) {
        button.addEventListener('click', nudge, true);
      });
      payment.forEach(function (wrap) {
        wrap.addEventListener('click', nudge, true);
      });
      sizeOption.addEventListener('animationend', function () {
        sizeOption.classList.remove('is-asking');
      });
    });
  }

  function init() {
    setup(document);
    // The quick view swaps its product markup in on every open and on every
    // colour change inside it (theme.js quickViewModal).
    var modal = document.querySelector('[data-quick-view-modal]');
    if (!modal) return;
    new MutationObserver(function () {
      setup(modal);
    }).observe(modal, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/*
  Product page: product videos play on their own, muted, while at least half
  of the video is on screen, and pause when it leaves (including a mobile
  carousel slide swiped away), so nothing plays out of sight on mobile data.
  A shopper who pauses a video keeps it paused. Turned on per product section
  by the "Αυτόματη αναπαραγωγή βίντεο" setting (data-autoplay-video in
  snippets/media.liquid). Off when the visitor asks for reduced motion or data.
*/
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (navigator.connection && navigator.connection.saveData) return;
  if (!('IntersectionObserver' in window)) return;

  var visible = new Set();

  function play(video) {
    video.muted = true;
    var playing = video.play();
    if (playing && playing.catch) playing.catch(function () {});
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) visible.add(video);
        else visible.delete(video);
        if (video.dataset.userPaused) return;
        if (entry.isIntersecting) play(video);
        else if (!video.paused) video.pause();
      });
    },
    { threshold: 0.5 }
  );

  // The browser also pauses muted video when the page goes to the background
  // (switching apps on a phone). Only a pause right after a tap on the video
  // counts as the shopper's choice; coming back resumes what is on screen.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    visible.forEach(function (video) {
      if (!video.dataset.userPaused && video.paused) play(video);
    });
  });

  function init() {
    document.querySelectorAll('[data-autoplay-video] video').forEach(function (video) {
      if (video.dataset.autoplayObserved) return;
      video.dataset.autoplayObserved = 'true';
      // Carousel clones are never set up by the theme's player, so the
      // section's loop setting is applied to the element itself.
      if (video.closest('[data-loop="true"]')) video.loop = true;

      var media = video.closest('[data-autoplay-video]');
      var tappedAt = 0;
      media.addEventListener('pointerdown', function () {
        tappedAt = Date.now();
      }, true);
      video.addEventListener('pause', function () {
        if (!video.ended && document.visibilityState === 'visible' && Date.now() - tappedAt < 1000) {
          video.dataset.userPaused = 'true';
        }
      });
      video.addEventListener('play', function () {
        delete video.dataset.userPaused;
      });
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/*
  Sticky add-to-bag bar: shows the chosen size in the button
  ("Προσθήκη στην τσάντα · M · €49,90", snippets/sticky-atc-bar.liquid).
  Empty until a size tile is selected, so a size is never shown that the
  shopper did not choose.
*/
(function () {
  function sync(scope) {
    var slot = scope.querySelector('[data-sticky-size]');
    if (!slot) return;
    // A single size (ONE SIZE) is no choice, so it is not repeated in the button.
    var single = scope.querySelectorAll('[data-size-option] .product__chip').length < 2;
    var chosen = single || scope.hasAttribute('data-size-pending')
      ? null
      : scope.querySelector('[data-size-option] .product__chip.selected');
    slot.textContent = chosen ? chosen.textContent.trim() : '';
  }

  function init() {
    document.querySelectorAll('[data-size-option]').forEach(function (sizeOption) {
      if (sizeOption.closest('[data-quick-view-modal]')) return;
      var scope = sizeOption.closest('[data-section-type]') || document;
      sync(scope);
      // After the theme has moved the "selected" class to the tapped tile.
      sizeOption.addEventListener('click', function (event) {
        if (!event.target.closest('.product__chip')) return;
        setTimeout(function () {
          sync(scope);
        }, 0);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/*
  "Ολοκλήρωσε το σετ" (snippets/complete-the-set.liquid).
  Finds up to two pieces in the same fabric and colour from the other half of
  the outfit (tops for bottoms, bottoms for tops) with Shopify's predictive
  search, shows their sizes, and adds the chosen size to the bag. The theme
  refreshes its bag and header count on "apps:product-added-to-cart" (the
  hook it keeps for apps), then the bag is opened via the header bag icon.
*/
(function () {
  var TOPS = ['ΑΘΛΗΤΙΚΑ ΤΟΠ', 'BRA', 'ΜΠΛΟΥΖΕΣ ΦΟΥΤΕΡ', 'ΑΘΛΗΤΙΚΕΣ ΜΠΛΟΥΖΕΣ', 'ΜΠΟΛΕΡΟ', 'OUTTERWEAR'];
  var BOTTOMS = ['ΚΟΛΑΝ', 'BOTTOM', 'ΠΑΝΤΕΛΟΝΙΑ', 'ΚΟΛΑΝ-ΠΑΝΤΕΛΟΝΙΑ', 'ΣΟΡΤΣ | BIKER ΚΟΛΑΝ', 'ΦΟΡΕΜΑΤΑ-ΦΟΥΣΤΕΣ'];
  // Extra search words that pull the other half to the top of the results
  var TOP_WORDS = ['top', 'μπουστάκι'];
  var BOTTOM_WORDS = ['κολάν', 'σορτς'];
  var MAX_ITEMS = 2;
  var SIZE_NAMES = ['μέγεθος', 'μεγεθος', 'size'];

  function norm(text) {
    return (text || '').toString().trim().toLowerCase();
  }

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function search(query) {
    var url =
      '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=10&resources[options][fields]=title';
    return fetch(url)
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) { return (data && data.resources.results.products) || []; })
      .catch(function () { return []; });
  }

  function isMatch(result, block) {
    var parts = (result.title || '').split('|');
    if (parts.length < 2) return false;
    var base = norm(parts[0]);
    if (norm(parts[parts.length - 1]) !== norm(block.dataset.colour)) return false;
    if (base.indexOf(norm(block.dataset.fabric)) === -1) return false;
    if (/σετ|παιδικ|λόσωμ/.test(base)) return false;
    if (result.handle === block.dataset.handle || !result.available) return false;
    return block.wanted.indexOf((result.type || '').toUpperCase()) !== -1;
  }

  function renderItem(product) {
    var sizeIndex = -1;
    product.options.forEach(function (option, index) {
      if (SIZE_NAMES.indexOf(norm(option.name || option)) !== -1) sizeIndex = index;
    });
    var variants = product.variants;
    var single = variants.length === 1;

    var item = document.createElement('div');
    item.className = 'complete-set__item';
    var image = product.featured_image ? product.featured_image + (product.featured_image.indexOf('?') === -1 ? '?' : '&') + 'width=240' : '';
    var name = product.title.split('|')[0].trim();
    var price = variants[0].price;
    var compare = variants[0].compare_at_price;

    item.innerHTML =
      '<a class="complete-set__media" href="' + product.url + '">' +
        (image ? '<img src="' + image + '" alt="" loading="lazy" width="120" height="160">' : '') +
      '</a>' +
      '<div class="complete-set__body">' +
        '<a class="complete-set__name" href="' + product.url + '"></a>' +
        '<p class="complete-set__price">' +
          (compare && compare > price ? '<s>' + money(compare) + '</s> <span class="sale">' + money(price) + '</span>' : money(price)) +
        '</p>' +
        '<div class="complete-set__sizes" role="group"></div>' +
        '<button type="button" class="complete-set__add btn btn--secondary btn--small"></button>' +
        '<p class="complete-set__status" role="status" aria-live="polite"></p>' +
      '</div>';
    item.querySelector('.complete-set__name').textContent = name;

    var sizes = item.querySelector('.complete-set__sizes');
    var add = item.querySelector('.complete-set__add');
    var status = item.querySelector('.complete-set__status');
    var chosen = single ? variants[0] : null;
    sizes.setAttribute('aria-label', 'Μέγεθος για ' + name);

    function label() {
      add.textContent = chosen ? 'Προσθήκη' + (single ? '' : ' · ' + chosen.options[sizeIndex]) : 'Διάλεξε μέγεθος';
    }

    if (!single && sizeIndex !== -1) {
      variants.forEach(function (variant) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'complete-set__size';
        chip.textContent = variant.options[sizeIndex];
        chip.disabled = !variant.available;
        chip.setAttribute('aria-pressed', 'false');
        chip.addEventListener('click', function () {
          chosen = variant;
          sizes.querySelectorAll('.complete-set__size').forEach(function (other) {
            other.setAttribute('aria-pressed', other === chip ? 'true' : 'false');
          });
          status.textContent = '';
          label();
        });
        sizes.appendChild(chip);
      });
    } else {
      sizes.remove();
    }
    label();

    add.addEventListener('click', function () {
      if (!chosen) {
        sizes.classList.remove('is-asking');
        void sizes.offsetWidth;
        sizes.classList.add('is-asking');
        return;
      }
      add.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: chosen.id, quantity: 1 }] })
      })
        .then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok) throw new Error(body.description || body.message || 'error');
            return body;
          });
        })
        .then(function () {
          add.textContent = '✓ Στην τσάντα';
          document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
          var bagIcon = document.querySelector('[data-js-cart-icon]');
          if (bagIcon) setTimeout(function () { bagIcon.click(); }, 350);
          setTimeout(function () { add.disabled = false; label(); }, 2500);
        })
        .catch(function (error) {
          add.disabled = false;
          label();
          status.textContent = error.message && error.message !== 'error' ? error.message : 'Δεν μπήκε στην τσάντα, δοκίμασε ξανά.';
        });
    });
    sizes.addEventListener('animationend', function () {
      sizes.classList.remove('is-asking');
    });
    return item;
  }

  function fill(block) {
    var type = (block.dataset.type || '').toUpperCase();
    var words;
    if (BOTTOMS.indexOf(type) !== -1) {
      block.wanted = TOPS;
      words = TOP_WORDS;
    } else if (TOPS.indexOf(type) !== -1) {
      block.wanted = BOTTOMS;
      words = BOTTOM_WORDS;
    } else {
      return;
    }

    var base = block.dataset.fabric + ' ' + block.dataset.colour;
    var queries = [base].concat(words.map(function (word) { return word + ' ' + base; }));

    Promise.all(queries.map(search))
      .then(function (lists) {
        var seen = {};
        var matches = [];
        lists.forEach(function (list) {
          list.forEach(function (result) {
            // Some pieces exist twice under the same title; show each once
            var key = norm(result.title);
            if (seen[key] || !isMatch(result, block)) return;
            seen[key] = true;
            matches.push(result);
          });
        });
        return Promise.all(
          matches.slice(0, MAX_ITEMS).map(function (match) {
            return fetch('/products/' + match.handle + '.js')
              .then(function (res) { return res.ok ? res.json() : null; })
              .catch(function () { return null; });
          })
        );
      })
      .then(function (products) {
        var target = block.querySelector('[data-complete-set-items]');
        products.forEach(function (product) {
          if (product && product.available) target.appendChild(renderItem(product));
        });
        if (target.children.length) block.hidden = false;
      });
  }

  function init() {
    document.querySelectorAll('[data-complete-set]').forEach(fill);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/*
  Back in stock (snippets/product-form.liquid, data-back-in-stock).
  While a sold-out size is selected the theme disables Add to bag
  ("Εξαντλημένα"); this shows "Ειδοποίησέ με όταν ξαναέρθει το S" under it.
  The button opens the Omnisend pop-up form through Omnisend's custom trigger
  (window.omnisend.push(['openForm', id])). The selected variant is already in
  the page URL (?variant=…), which is how the form knows which size it is for.
*/
(function () {
  function init() {
    document.querySelectorAll('[data-back-in-stock]').forEach(function (notify) {
      var scope = notify.closest('[data-section-type]') || document;
      var atc = notify.parentElement.querySelector('[data-add-to-cart]');
      if (!atc) return;

      function selectedSize() {
        var chip = scope.querySelector('[data-size-option] .product__chip.selected');
        return chip ? chip.textContent.trim() : '';
      }

      function update() {
        var soldOut = atc.disabled && !scope.hasAttribute('data-size-pending');
        notify.hidden = !soldOut;
        if (soldOut) {
          var size = selectedSize();
          notify.textContent = notify.dataset.label + (size ? ' το ' + size : '');
        }
      }

      new MutationObserver(update).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
      scope.addEventListener('click', function (event) {
        if (event.target.closest('[data-size-option] .product__chip')) setTimeout(update, 0);
      });

      notify.addEventListener('click', function () {
        window.omnisend = window.omnisend || [];
        window.omnisend.push(['openForm', notify.dataset.formId]);
      });

      update();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/*
  Klarna line under the price (snippets/product-block-header.liquid):
  "ή 3 άτοκες δόσεις των €9,97 με Klarna". When a variant with another price
  is picked, the theme rewrites the price; this recomputes the third from it
  and hides the line below Klarna's minimum.
*/
(function () {
  function cents(text) {
    var digits = (text || '').replace(/[^\d,.]/g, '').replace(/\./g, '').replace(',', '.');
    var value = parseFloat(digits);
    return isNaN(value) ? 0 : Math.round(value * 100);
  }

  function money(amount) {
    return '€' + (amount / 100).toFixed(2).replace('.', ',');
  }

  function init() {
    document.querySelectorAll('[data-klarna-line]').forEach(function (line) {
      var header = line.parentElement;
      var price = header && header.querySelector('.product__price [data-price]');
      var amount = line.querySelector('[data-klarna-amount]');
      if (!price || !amount) return;
      var min = parseInt(line.dataset.klarnaMin, 10) || 0;

      function update() {
        var total = cents(price.textContent);
        line.hidden = !total || total < min;
        if (total) amount.textContent = money(Math.round(total / 3));
      }

      new MutationObserver(update).observe(price, { childList: true, characterData: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/*
  Pause button for product videos (card videos on collection pages and the
  product page gallery). Some shoppers get dizzy from moving video, so one
  small floating pill sits bottom-left of the screen while a video is in view:
  one tap stops every video on the site for that visitor and is remembered
  (localStorage) on later pages and visits; tapping again plays them. Videos
  that start on their own are stopped while the choice is "paused"; a video
  the shopper starts herself still plays.
*/
(function () {
  var KEY = 'baya:videos-paused';
  var VIDEOS = 'video[data-product-card-video], [data-autoplay-video] video';
  var PAUSE_ICON = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M3 1.5h2v9H3zM7 1.5h2v9H7z" fill="currentColor"/></svg>';
  var PLAY_ICON = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M3 1.5l7 4.5-7 4.5z" fill="currentColor"/></svg>';

  function isPaused() {
    try {
      return localStorage.getItem(KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setPaused(paused) {
    try {
      if (paused) localStorage.setItem(KEY, '1');
      else localStorage.removeItem(KEY);
    } catch (e) {}
  }

  // A play that follows the shopper's own tap on that video is hers to keep.
  var lastTap = { time: 0, target: null };
  document.addEventListener('pointerdown', function (event) {
    lastTap = { time: Date.now(), target: event.target };
  }, true);

  function startedByShopper(video) {
    if (Date.now() - lastTap.time > 1000 || !lastTap.target) return false;
    var box = video.closest('.media, .product-item__media') || video;
    return box.contains(lastTap.target);
  }

  // "play" does not bubble, so listen in the capture phase.
  document.addEventListener('play', function (event) {
    var video = event.target;
    if (!(video instanceof HTMLVideoElement) || !video.matches(VIDEOS)) return;
    if (isPaused() && !startedByShopper(video)) video.pause();
  }, true);

  function onScreen(video) {
    var box = video.getBoundingClientRect();
    return box.bottom > 0 && box.top < window.innerHeight && box.width > 0;
  }

  var button = null;
  var visible = new Set();

  function paint() {
    var paused = isPaused();
    button.innerHTML = (paused ? PLAY_ICON : PAUSE_ICON) +
      '<span>' + (paused ? 'Αναπαραγωγή βίντεο' : 'Παύση βίντεο') + '</span>';
    button.setAttribute('aria-pressed', paused ? 'true' : 'false');
  }

  function toggle() {
    var paused = !isPaused();
    setPaused(paused);
    document.querySelectorAll(VIDEOS).forEach(function (video) {
      if (paused) {
        video.pause();
      } else if (video.currentSrc && onScreen(video)) {
        video.muted = true;
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () {});
      }
    });
    paint();
  }

  // Sit above the product page's sticky add-to-bag bar when it is showing
  function placeAboveStickyBar() {
    var bar = document.querySelector('.sticky-atc-bar');
    var lift = 0;
    if (bar && bar.offsetHeight) {
      var top = bar.getBoundingClientRect().top;
      if (top < window.innerHeight) lift = window.innerHeight - top;
    }
    button.style.setProperty('--video-toggle-lift', lift + 'px');
  }

  var placeQueued = false;
  function queuePlace() {
    if (placeQueued) return;
    placeQueued = true;
    requestAnimationFrame(function () {
      placeQueued = false;
      placeAboveStickyBar();
    });
  }

  function update() {
    var show = visible.size > 0;
    button.classList.toggle('is-visible', show);
    button.tabIndex = show ? 0 : -1;
    button.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (show) queuePlace();
  }

  var watcher = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) visible.add(entry.target);
      else visible.delete(entry.target);
    });
    update();
  });

  function scan() {
    document.querySelectorAll(VIDEOS).forEach(function (video) {
      if (video.hasAttribute('data-video-toggle-watched')) return;
      video.setAttribute('data-video-toggle-watched', '');
      watcher.observe(video);
    });
    // Videos removed by filtering or colour swaps no longer count
    visible.forEach(function (video) {
      if (!video.isConnected) visible.delete(video);
    });
    update();
  }

  function init() {
    button = document.createElement('button');
    button.type = 'button';
    button.className = 'video-toggle';
    button.setAttribute('data-video-toggle', '');
    button.addEventListener('click', toggle);
    paint();
    document.body.appendChild(button);

    window.addEventListener('scroll', queuePlace, { passive: true });
    window.addEventListener('resize', queuePlace);
    scan();

    // Cards arrive later with filtering, infinite scroll and colour swaps
    var queued = false;
    new MutationObserver(function (mutations) {
      if (queued) return;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length && mutations[i].target !== button && !button.contains(mutations[i].target)) {
          queued = true;
          requestAnimationFrame(function () {
            queued = false;
            scan();
          });
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/*
  "Ανοιχτά τώρα" next to the customer service phone (snippets/contact-phone.liquid)
  during opening hours, Monday to Friday 9:00–16:00 Athens time. Pages are
  cached, so this has to be worked out in the browser.
*/
(function () {
  function isOpen() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Athens',
        weekday: 'short',
        hour: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(new Date());
      var day = '';
      var hour = -1;
      parts.forEach(function (part) {
        if (part.type === 'weekday') day = part.value;
        if (part.type === 'hour') hour = parseInt(part.value, 10);
      });
      return ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(day) !== -1 && hour >= 9 && hour < 16;
    } catch (e) {
      return false;
    }
  }

  function paint() {
    var open = isOpen();
    document.querySelectorAll('[data-contact-open]').forEach(function (badge) {
      badge.hidden = !open;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint);
  else paint();
  // The product block re-renders after a variant tap, which brings the badge back hidden
  document.addEventListener('click', function () { setTimeout(paint, 600); }, true);
})();
